import { render } from "./PatternDiagrams.vue?vue&type=template&id=956d0538&scoped=true&ts=true"
import script from "./PatternDiagrams.vue?vue&type=script&lang=ts"
export * from "./PatternDiagrams.vue?vue&type=script&lang=ts"

import "./PatternDiagrams.vue?vue&type=style&index=0&id=956d0538&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-956d0538"]])

export default __exports__